/* tslint:disable */
/* eslint-disable */
/**
 * Telematics backend API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    CustomPlaceCrossingType,
    CustomPlaceCrossingTypeFromJSON,
    CustomPlaceCrossingTypeFromJSONTyped,
    CustomPlaceCrossingTypeToJSON,
} from './';

/**
 * 
 * @export
 * @interface CustomPlaceCrossing
 */
export interface CustomPlaceCrossing {
    /**
     * 
     * @type {string}
     * @memberof CustomPlaceCrossing
     */
    monitoredObjectId?: string;
    /**
     * 
     * @type {number}
     * @memberof CustomPlaceCrossing
     */
    clientId: number;
    /**
     * 
     * @type {string}
     * @memberof CustomPlaceCrossing
     */
    customPlaceId: string;
    /**
     * 
     * @type {Date}
     * @memberof CustomPlaceCrossing
     */
    timestamp: Date;
    /**
     * 
     * @type {CustomPlaceCrossingType}
     * @memberof CustomPlaceCrossing
     */
    type: CustomPlaceCrossingType;
    /**
     * 
     * @type {Date}
     * @memberof CustomPlaceCrossing
     */
    createdAt?: Date;
    /**
     * 
     * @type {Date}
     * @memberof CustomPlaceCrossing
     */
    deletedAt?: Date;
}

export function CustomPlaceCrossingFromJSON(json: any): CustomPlaceCrossing {
    return CustomPlaceCrossingFromJSONTyped(json, false);
}

export function CustomPlaceCrossingFromJSONTyped(json: any, ignoreDiscriminator: boolean): CustomPlaceCrossing {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'monitoredObjectId': !exists(json, 'monitored_object_id') ? undefined : json['monitored_object_id'],
        'clientId': json['client_id'],
        'customPlaceId': json['custom_place_id'],
        'timestamp': (new Date(json['timestamp'])),
        'type': CustomPlaceCrossingTypeFromJSON(json['type']),
        'createdAt': !exists(json, 'created_at') ? undefined : (new Date(json['created_at'])),
        'deletedAt': !exists(json, 'deleted_at') ? undefined : (new Date(json['deleted_at'])),
    };
}

export function CustomPlaceCrossingToJSON(value?: CustomPlaceCrossing | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'monitored_object_id': value.monitoredObjectId,
        'client_id': value.clientId,
        'custom_place_id': value.customPlaceId,
        'timestamp': (value.timestamp.toISOString()),
        'type': CustomPlaceCrossingTypeToJSON(value.type),
        'created_at': value.createdAt === undefined ? undefined : (value.createdAt.toISOString()),
        'deleted_at': value.deletedAt === undefined ? undefined : (value.deletedAt.toISOString()),
    };
}


